/*
 * Brandawi CTA: "Customize yours" + WhatsApp help link on the main product page.
 * Markup: snippets/bd-cta.liquid. WhatsApp greeting, URL and GA4 event come from
 * window.HJWhatsApp (layout/theme.liquid); nothing about attribution is duplicated here.
 */
(function () {
  'use strict';

  if (window.BrandawiCta) return;
  window.BrandawiCta = { instances: [] };

  var instances = window.BrandawiCta.instances;
  var variantListenerBound = false;

  // Matches the floating button's guard in layout/theme.liquid (now - lastWhatsAppClick < 1500).
  var DOUBLE_CLICK_MS = 1500;

  // Product link labels; the floating button keeps its own (floating_whatsapp_button / floating_button).
  var TRACK_PARAMS = {
    event_label: 'product_page_whatsapp_link',
    button_location: 'product_page',
    placement: 'product_page'
  };

  function parseJson(node) {
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function getWhatsAppApi() {
    var api = window.HJWhatsApp;
    if (api && typeof api.buildUrl === 'function' && typeof api.getGreeting === 'function') {
      return api;
    }
    return null;
  }

  function Cta(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.customize = root.querySelector('[data-bd-cta-customize]');
    this.whatsapp = root.querySelector('[data-bd-cta-whatsapp]');
    this.data = parseJson(root.querySelector('[data-bd-cta-json]'));
    this.variantId = this.data.variantId ? String(this.data.variantId) : null;
    this.variantTitle = this.data.variantTitle || '';
    this.lastWhatsAppClick = 0;

    if (this.whatsapp) {
      this.whatsapp.addEventListener('click', this.onWhatsAppClick.bind(this));
      this.refreshWhatsApp();
    }
  }

  Cta.prototype.setVariant = function (variant) {
    this.variantId = variant && variant.id ? String(variant.id) : null;
    this.variantTitle = variant && variant.title ? variant.title : '';

    if (this.customize) {
      var rts = this.data.rts || {};
      this.customize.hidden = !(this.variantId && rts[this.variantId] === true);
    }
    if (this.whatsapp) {
      this.refreshWhatsApp();
    }
  };

  Cta.prototype.buildMessage = function (greeting) {
    var data = this.data;
    if (!data.includeDetails) return greeting;

    var line = data.prefix ? data.prefix + ' ' + data.title : data.title;
    var url = data.productUrl;
    if (!data.hasOnlyDefaultVariant && this.variantId) {
      if (this.variantTitle) line += ' - ' + this.variantTitle;
      url += '?variant=' + this.variantId;
    }
    return greeting + '\n' + line + '\n' + url;
  };

  // Returns { url, fromGoogleAds }, or null when the attribution API is missing (keeps the server href).
  Cta.prototype.refreshWhatsApp = function () {
    var api = getWhatsAppApi();
    if (!api) return null;
    try {
      var fromGoogleAds = api.isAdsVisit();
      var url = api.buildUrl(this.buildMessage(api.getGreeting(fromGoogleAds)));
      this.whatsapp.setAttribute('href', url);
      return { url: url, fromGoogleAds: fromGoogleAds };
    } catch (e) {
      return null;
    }
  };

  Cta.prototype.onWhatsAppClick = function (evt) {
    // Same 1.5s double-click guard as the floating button: a second tap opens nothing and tracks nothing.
    var now = Date.now();
    if (now - this.lastWhatsAppClick < DOUBLE_CLICK_MS) {
      if (evt && evt.preventDefault) evt.preventDefault();
      return;
    }
    this.lastWhatsAppClick = now;

    // Rebuild at click time (gclid may have been stored after load), then let the link open normally.
    var result = this.refreshWhatsApp();
    var api = getWhatsAppApi();
    if (!result || !api || typeof api.trackClick !== 'function') return;
    try {
      api.trackClick(result.url, result.fromGoogleAds, TRACK_PARAMS);
    } catch (e) {}
  };

  function bindVariantChange() {
    if (variantListenerBound || !window.jQuery) return;
    variantListenerBound = true;
    // Read-only listener on the theme's own event (wpbingo.Variants triggers it on the section container).
    window.jQuery(document).on('variantChange.bdCta', function (evt) {
      var sectionId = window.jQuery(evt.target).closest('[data-section-id]').attr('data-section-id');
      for (var i = 0; i < instances.length; i++) {
        if (instances[i].sectionId === sectionId) {
          instances[i].setVariant(evt.variant);
        }
      }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bd-cta]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-bd-cta-init') === 'true') continue;
      roots[i].setAttribute('data-bd-cta-init', 'true');
      instances.push(new Cta(roots[i]));
    }
    if (instances.length) bindVariantChange();
  }

  // jQuery is deferred and loads after this file, so wait for DOMContentLoaded; 'load' is a no-op safety net.
  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
